import { atom } from 'jotai';

// Dialog visibility atoms
export const $showUploadDialog = atom(false);
export const $showCreateFolderDialog = atom(false);
export const $showRenameDialog = atom(false);
export const $showMoveDialog = atom(false);
export const $showDeleteDialog = atom(false);
// Bulk operation dialog atoms
export const $showBulkDeleteDialog = atom(false);
export const $showBulkMoveDialog = atom(false);

// Dialog data atoms
export const $selectedFileForAction = atom<string | null>(null);

// New state for template dialog
export const $templateDialogFileId = atom<string | null>(null);
